import React, { useEffect, useState } from "react";
import "./styles.scss";
import "react-notifications-component/dist/theme.css";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Button, DropBox, FormHeader, InputBox } from "../../../components";
import { CheckValidity } from "../../../utils/formValidity";
import { createNewMenus, updateMenu } from "./service/menus.service";
import CategorySelectBox from "../../templates/categorySelectBox";
import { Store } from "react-notifications-component";
import { useDispatch, useSelector } from "react-redux";
import { addList, updateList } from "../../Menus/redux/actions";

const CreateNewMenus = () => {
  const dispatch = useDispatch();
  const selectedMenu = useSelector((state) => state.menuReducer.selectMenu);
  const [language, setLanguage] = useState("si");

  const [formData, setFormData] = useState({
    menuNameSI: {
      key: "menuNameSI",
      label: "Menu name (SI)",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    menuNameEN: {
      key: "menuNameEN",
      label: "Menu name (EN)",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    category: {
      key: "category",
      label: "Category",
      size: "lg",
      placeholder: "-",
      mainLayerStyles: " flex-column " + " align-content-center " + "mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    status: {
      key: "status",
      label: "Status",
      size: "lg",
      placeholder: "-- Select Status --",
      mainLayerStyles: " flex-column " + " align-content-center " + "mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [
          { value: "active", displayValue: "Active" },
          { value: "deactive", displayValue: "Deactive" },
        ],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = async (event, inputIdentity) => {
    const updateForm = {
      ...formData,
    };

    updateForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateForm[inputIdentity].value,
      updateForm[inputIdentity].validation
    );

    if (validityRes) {
      updateForm[inputIdentity].isValid = validityRes.isValid;
      updateForm[inputIdentity].invalidReason = validityRes.reason;
      updateForm[inputIdentity].value = event;
      updateForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateForm) {
        formIsValid = updateForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateForm);
    }
  };
  useEffect(() => {
    if (selectedMenu?.menu_id) {
      console.log("id", selectedMenu?.menu_id);
      const updateForm = {
        ...formData,
      };
      updateForm.menuNameSI.value = selectedMenu?.menu_name?.si;
      updateForm.menuNameEN.value = selectedMenu?.menu_name?.en;
      setFormData(updateForm);
    } else {
      for (let key in updateForm) {
        console.log(updateForm[key]);
        updateForm[key].value = "";
        updateForm[key].isValid = false;
        updateForm[key].touched = false;
      }
      setFormData(updateForm);
    }
  }, [selectedMenu]);

  const clearAll = () => {
    const updateForm = {
      ...formData,
    };
    for (let key in updateForm) {
      console.log(updateForm[key]);
      updateForm[key].value = "";
      updateForm[key].isValid = false;
      updateForm[key].touched = false;
    }
    // categorySelect([]);
    setFormData(updateForm);
  };

  const onChange = (key) => {
    console.log(key);
  };

  const categorySelect = (value) => {
    console.log({ value });
    const updateForm = { ...formData };
    updateForm["category"].value = value;
    setFormData(updateForm);
  };

  const onClickSave = async () => {
    setIsLoading(true);
    setIsButtonDisabled(true);

    const updateForm = {
      ...formData,
    };
    if (selectedMenu?.menu_id) {
      console.log("selectedMenu", selectedMenu?.menu_id);
      try {
        const result = await updateMenu(
          {
            menu_name: {
              si: updateForm.menuNameSI.value,
              en: updateForm.menuNameEN.value,
            },
            category: updateForm.category.value,
            status: updateForm.status.value,
          },
          selectedMenu?.menu_id
        );
        console.log("Menu details ===", result);

        if (result?.data) {
          dispatch(updateList(result?.data));
          Store.addNotification({
            title: "Success!",
            message: "Menu Updated Successfully!",
            type: "success",
            insert: "top",
            container: "top-right",
            dismiss: { duration: 3000, onScreen: true },
          });
          setIsLoading(false);
          setIsButtonDisabled(false);
          clearAll();
        } else {
          Store.addNotification({
            title: "Error!",
            message: "Menu Update Failed!",
            type: "danger",
            insert: "top",
            container: "top-right",
            dismiss: { duration: 3000, onScreen: true },
          });
          setIsLoading(false);
        }
      } catch (error) {
        console.log("Error ===", error);
        Store.addNotification({
          title: "Error!",
          message: "Menu Update Failed!",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        setIsButtonDisabled(false);
      }
    } else {
      const response = await createNewMenus({
        menu_name: {
          si: updateForm.menuNameSI.value,
          en: updateForm.menuNameEN.value,
        },
        category: updateForm.category.value,
        status: "new",
      });
      console.log("Menu details ===", response);

      console.log("Menu Create Successfully");
      try {
        if (response?.data) {
          dispatch(addList(response?.data));
          Store.addNotification({
            title: "Success!",
            message: "Menu Create Successfully!",
            type: "success",
            insert: "top",
            container: "top-right",
            dismiss: { duration: 3000, onScreen: true },
          });

          setIsLoading(false);
          setIsButtonDisabled(false);
          clearAll();
        }
      } catch (error) {
        console.log("Error fetching Menus", error);
        Store.addNotification({
          title: "Error!",
          message: "Menu Failed!",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        setIsButtonDisabled(false);
      }
    }
  };

  const updateForm = { ...formData };

  return (
    <>
      <div className="hne-create-menu-wrapper">
        <FormHeader
          data={{
            formHeader: "Create New Menus",
            size: "md-md",
          }}
        />

        <InputBox
          data={updateForm.menuNameSI}
          onChange={async (e) => {
            e.preventDefault();
            await handleChange(e.target.value, updateForm.menuNameSI.key);
          }}
        />
        <InputBox
          data={updateForm.menuNameEN}
          onChange={async (e) => {
            e.preventDefault();
            await handleChange(e.target.value, updateForm.menuNameEN.key);
          }}
        />

        {/* <div>
          <DropBox
            data={updateForm.category}
            onChange={(e) => {
              const updateForm = { ...formData };
              updateForm["category"].value = e;
              setFormData(updateForm);
              // dispatch(setCategoryDetails(e));
            }}
          />
        </div>*/}

        <CategorySelectBox
          onChangeCategory={categorySelect}
          data={{
            language: language,
          }}
        />
        {selectedMenu?.menu_id && (
          <DropBox
            data={updateForm.status}
            onChange={(value) => {
              const updateForm = { ...formData };
              updateForm["status"].value = value;
              setFormData(updateForm);
              // dispatch(setCategoryDetails(e));
            }}
          />
        )}

        <Button
          data={{
            btnName: "Done",
            buttonType:
              updateForm.menuNameSI.value === "" ||
              updateForm.menuNameEN.value === "" ||
              updateForm.category.value === "" ||
              updateForm.status.value === ""
                ? "primary disabled"
                : "primary",
            buttonSize: "lg",
            isLoading: isLoading,
          }}
          onClick={async (e) => {
            e.preventDefault();
            await onClickSave(e);
          }}
        />
      </div>
    </>
  );
};
export default withRouter(CreateNewMenus);
